import React from "react";

import { useAppSelector } from "../redux/Store";
import { ITRFilingSelector } from "../redux/slice/ITRFilingSlice";

type Props = {
  children: JSX.Element;
};

const PreventEditComponent: React.FC<Props> = (props: Props) => {
  const { children } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  if (isFilingReadOnly) {
    return <></>;
  } else {
    return children;
  }
};

export default PreventEditComponent;
